module.exports = __webpack_public_path__ + "media/images/icons/close-82503773323a5c4650d63f3508207ed1.svg";